<template>
    <div class="form-fssc22000-detail">
        <div
            v-for="item in displayItems"
            :key="item.key"
            class="row mb-2"
        >
            <div class="col-sm-6 font-weight-bold">{{ item.label }}</div>
            <div class="col-sm-6">{{ item.value }}</div>
        </div>
    </div>
</template>

<script>
import {
    symptomOptions,
    trainingOptions,
    formatFssc22000Boolean,
    labelForFssc22000Option,
} from '../../../utils/fssc22000Labels'

const booleanFields = [
    {
        key: 'is_in_good_health_today',
        label: '¿Se siente en buenas condiciones de salud hoy?',
    },
    {
        key: 'has_current_wound_or_injury',
        label: '¿Presenta actualmente alguna herida, corte o lesión en manos, brazos o cara?',
    },
    {
        key: 'is_under_medical_treatment',
        label: '¿Está bajo tratamiento médico o consume medicamentos actualmente?',
    },
    {
        key: 'diagnosed_with_infectious_disease_last_month',
        label: '¿Le han diagnosticado en el último mes alguna enfermedad infecciosa?',
    },
    {
        key: 'has_gastrointestinal_symptoms',
        label: '¿Presenta síntomas gastrointestinales?',
    },
    {
        key: 'had_recent_contact_with_infectious_person',
        label: '¿Ha tenido contacto reciente con personas enfermas o con diagnóstico infeccioso?',
    },
    {
        key: 'has_unprotected_wounds_near_food',
        label: '¿Tiene heridas o lesiones sin protección que puedan entrar en contacto con los alimentos?',
    },
    {
        key: 'uses_ppe_correctly',
        label: '¿Usa correctamente sus elementos de protección personal (EPP)?',
    },
]

export default {
    props: {
        form: {
            type: Object,
            default: null,
        },
    },
    computed: {
        displayItems() {
            if (!this.form) {
                return []
            }

            const items = [
                { key: 'pension_fund', label: 'Fondo de pensiones', value: this.form.pension_fund },
                { key: 'eps', label: 'EPS', value: this.form.eps },
                {
                    key: 'emergency_contact_name',
                    label: 'Nombre de contacto de emergencia',
                    value: this.form.emergency_contact_name,
                },
                {
                    key: 'emergency_contact_phone',
                    label: 'Celular de contacto de emergencia',
                    value: this.form.emergency_contact_phone,
                },
            ]

            booleanFields.forEach(({ key, label }) => {
                items.push({
                    key,
                    label,
                    value: formatFssc22000Boolean(this.form[key]),
                })
            })

            items.push({
                key: 'symptoms_last_7_days',
                label: 'En los últimos 7 días, ¿ha presentado alguno de los siguientes síntomas?',
                value: labelForFssc22000Option(symptomOptions, this.form.symptoms_last_7_days),
            })

            items.push({
                key: 'food_handling_training_status',
                label: '¿Ha recibido capacitación en Manipulación de Alimentos y Buenas Prácticas Higiénicas?',
                value: labelForFssc22000Option(trainingOptions, this.form.food_handling_training_status),
            })

            return items
        },
    },
}
</script>
